import { useState } from 'react';
import { Box, Link, Skeleton, styled, Typography } from '@mui/material';
import StatusTable from './status-table';
import Legend from './legend';
import QueryHealthData from './query-health-data';
import { ParsedStatusesFrontend } from '../../utils/types';
import { HEADER_MESSAGE_BY_STATUS, TECH_OPS_EMAIL } from '../../utils/consts';
import HelpfulAlerts from './helpful-alerts';

const Home = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [healthData, setHealthData] = useState<ParsedStatusesFrontend>({
    overallStatus: 'unknown',
    problemApps: [],
  });

  return (
    <>
      <QueryHealthData
        dataSetter={setHealthData}
        loadingSetter={setIsLoading}
      />
      <Box sx={{ width: '100%', textAlign: 'center' }}>
        <Typography variant="h4" mb={2} data-testid="headerMessage">
          {isLoading
            ? 'Loading...'
            : HEADER_MESSAGE_BY_STATUS[healthData.overallStatus]}
        </Typography>
        <Typography variant="h6" mb={2}>
          Having trouble? Troubleshoot connection issues or email us at{' '}
          <Link color="inherit" href={`mailto:${TECH_OPS_EMAIL}`}>
            {TECH_OPS_EMAIL}
          </Link>
        </Typography>
        {!isLoading && <HelpfulAlerts healthData={healthData} />}
        <Legend />
        {isLoading ? (
          <SkeletonTable />
        ) : (
          <StatusTable healthData={healthData.rawData} />
        )}
      </Box>
    </>
  );
};

const SkeletonTable = () => {
  return (
    <>
      <StyledSkeleton variant="rounded" />
      <StyledSkeleton variant="rounded" />
      <StyledSkeleton variant="rounded" />
      <StyledSkeleton variant="rounded" />
      <StyledSkeleton variant="rounded" />
    </>
  );
};

const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  width: '100%',
  height: '60px',
}));

export default Home;
